import Cookie from 'utils/cookies';
import reducerRegistry from '../../../reduxUtils/reducerRegistry';
import makeRequest from '../../../utils/makeRequest';
import { ABOUND_BACKEND_SERVICE_DOMAIN } from '../../../constants';
import { getAboundToken, getSsoid } from './AboundUtils';

const reducerName = 'abound';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const LOGIN_POINTS_RECEIVED = createActionName('LOGIN_POINTS_RECEIVED');
export const ABOUND_POINTS_RECEIVED = createActionName(
  'ABOUND_POINTS_RECEIVED',
);
export const HANDLE_ABOUND_SIGNUP_CHECKED = createActionName(
  'HANDLE_ABOUND_SIGNUP_CHECKED',
);
export const ALREADY_ABOUND_POINTS_RECEIVED = createActionName(
  'ALREADY_ABOUND_POINTS_RECEIVED',
);
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');

export const DATA_LOADING = createActionName('DATA_LOADING');

export const DATA_LOADED = createActionName('DATA_LOADED');

function receiveAboundData(data) {
  return {
    type: LOGIN_POINTS_RECEIVED,
    payload: data,
  };
}

function receiveAboundPointsData(data) {
  return {
    type: ABOUND_POINTS_RECEIVED,
    payload: data,
  };
}

function receiveAlreadyAboundPointsData(data) {
  return {
    type: ALREADY_ABOUND_POINTS_RECEIVED,
    payload: data,
  };
}

export function handleAboundSignupChecked(data) {
  return {
    type: HANDLE_ABOUND_SIGNUP_CHECKED,
    payload: data,
  };
}

export function handleDataError(data = null) {
  return {
    type: HANDLE_DATA_ERROR,
    payload: {
      data,
    },
  };
}

export function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

export function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

function aboundSignUp({ ssoid, phoneNumber, email, signup = true }) {
  const ssoId = ssoid || Cookie.get('ssoid') || Cookie.get('ssoId');
  if (
    typeof window !== 'undefined' &&
    window.geoinfo &&
    typeof window.geoinfo.CountryCode === 'string' &&
    window.geoinfo.CountryCode !== 'US'
  ) {
    return Promise.reject(
      Object.assign(new Error('Location is not enabled'), {
        success: false,
        message: 'Location is not enabled',
        status_code: 'LOCATION_NOT_ENABLED',
      }),
    );
  }
  if (!(phoneNumber || email)) {
    return Promise.reject(
      Object.assign(new Error('No mobile and Email found'), {
        success: false,
        message: 'No mobile and Email found',
        status_code: 'NO_EMAIL_MOBILE_FOUND',
      }),
    );
  }
  let data = {};
  if (phoneNumber) {
    data = {
      mobileNumber: phoneNumber,
    };
  } else if (email) {
    data = {
      email,
    };
  }
  return makeRequest.post(
    `${ABOUND_BACKEND_SERVICE_DOMAIN}/ufs-utility/api/v1/abound/${
      signup ? 'signup' : 'signin'
    }?ssoid=${ssoId}`,
    data,
  );
}

function earnAboundPointAPICall({ msid, actType }) {
  if (
    typeof window !== 'undefined' &&
    window.geoinfo &&
    typeof window.geoinfo.CountryCode === 'string' &&
    window.geoinfo.CountryCode !== 'US'
  ) {
    return Promise.reject(
      Object.assign(new Error('Location is not enabled'), {
        success: false,
        message: 'Location is not enabled',
        status_code: 'LOCATION_NOT_ENABLED',
      }),
    );
  }
  // return Promise.reject(
  //   Object.assign(new Error('DISABLED ABOUND'), {
  //     success: false,
  //     message: 'DISABLED ABOUND',
  //     status_code: 'DISABLED_ABOUND',
  //   }),
  // );
  // eslint-disable-next-line no-unreachable
  const ssoId = getSsoid();
  const clientToken = getAboundToken();
  let msidExists = false;
  try {
    if (ssoId) {
      const msids = JSON.parse(localStorage.getItem('aboundEarnedMsids'))[
        ssoId
      ];
      msidExists = !!(
        msids &&
        Array.isArray(msids) &&
        msids.indexOf(msid) > -1
      );
    } else {
      localStorage.removeItem('aboundEarnedMsids');
    }
  } catch (error) {
    // Not found is the local storage
  }
  if (ssoId && clientToken && !msidExists) {
    return makeRequest.post(
      `${ABOUND_BACKEND_SERVICE_DOMAIN}/ufs-utility/api/v1/abound/activity?ssoid=${ssoId}`,
      {
        msid,
        actType,
      },
      {
        headers: {
          clientToken,
        },
      },
    );
  }
  if (!clientToken) {
    return Promise.reject(
      Object.assign(new Error('NO TOKEN'), {
        success: false,
        message: 'NO TOKEN',
        status_code: 'NO_TOKEN',
      }),
    );
  }
  return Promise.resolve({
    msid,
    actType,
  });
}

export function loadLoginAboundPoints({ ssoid, phoneNumber, email, signup }) {
  return dispatch => {
    dispatch(dataLoading());
    aboundSignUp({ ssoid, phoneNumber, email, signup })
      .then(response => {
        dispatch(dataLoaded());
        dispatch(receiveAboundData(response.data));
      })
      .catch(error => {
        dispatch(dataLoaded());
        dispatch(
          handleDataError(
            error?.response?.data?.message || error?.response?.data,
          ),
        );
      });
  };
}

export function earnAboundPoints(data) {
  return dispatch => {
    earnAboundPointAPICall(data)
      .then(response => {
        dispatch(receiveAboundPointsData({ ...response.data, ...data }));
      })
      .catch(error => {
        if (
          error?.status_code === 'NO_TOKEN' ||
          error?.response?.data?.status_code ===
            'Token_Parsing_Error_Record_Activity_Api'
        ) {
          aboundSignUp({ ...data, signup: false }).then(signupResponse => {
            const newToken = signupResponse?.data?.clientToken;
            Cookie.set('aboundToken', newToken, 30, '/');
            data.clientToken = newToken;
            earnAboundPointAPICall(data).then(retryResponse => {
              dispatch(
                receiveAboundPointsData({ ...retryResponse.data, ...data }),
              );
            });
          });
        } else if (error?.response?.status === 424) {
          dispatch(receiveAlreadyAboundPointsData(data));
        }
      });
  };
}

const setAboundDataInStorage = msid => {
  try {
    const ssoid = getSsoid();
    const msids =
      JSON.parse(localStorage.getItem('aboundEarnedMsids'))?.[ssoid] || [];
    if (ssoid) {
      localStorage.setItem(
        'aboundEarnedMsids',
        JSON.stringify({
          [ssoid]: [msid, ...msids.slice(0, 100)],
        }),
      );
    }
  } catch (error) {
    //
  }
};

export default function reducer(state = {}, action) {
  switch (action.type) {
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
        error: null,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
        error: null,
      };
    }
    case HANDLE_DATA_ERROR: {
      return {
        ...state,
        error: action.payload.data,
        userData: { clientToken: 'NOT_EXIST' },
      };
    }
    case LOGIN_POINTS_RECEIVED:
      Cookie.set('aboundToken', action.payload?.clientToken, 30, '/');
      return {
        ...state,
        userData: action.payload,
        error: null,
      };
    case ALREADY_ABOUND_POINTS_RECEIVED:
    case ABOUND_POINTS_RECEIVED:
      setAboundDataInStorage(action.payload?.msid);
      return {
        ...state,
      };
    case HANDLE_ABOUND_SIGNUP_CHECKED:
      return {
        ...state,
        isAboundSignupChecked: action.payload,
      };
    default:
      return state;
  }
}
reducerRegistry.register(reducerName, reducer);
